<app-responsive-dropdown-scaffold [(ngModel)]="selectedDevice" #dropdownScaffold (ngModelChange)="onSelectionChange()">
  <div dropdown [ngClass]="{open: dropdownScaffold.panelOpen}" class="device-dropdown" [title]="getSelectedItemText()">
    <!-- We assume that the dropdown is loading if the deviceService does not contain an active device -->
    <div *ngIf="selectedDevice; else dropdownLoading" class="d-flex overflow-hidden">
      <fa-icon [icon]="selectedDevice.device.type === DeviceType.CB ? ['fas', 'mobile-alt'] : ['fas', 'desktop']" class="device-icon"></fa-icon>
      <!-- Variant with flex overflow (not used because grid yields better results but this solution has better IE support) -->
      <!-- <span class="d-flex overflow-hidden">
        <span *ngIf="selectedDevice.username != null" class="text-truncate">{{selectedDevice.username}}</span>
        <span *ngIf="selectedDevice.username != null" class="flex-shrink-0">&nbsp;–&nbsp;</span>
        <span class="text-truncate">{{selectedDevice.device.name}}</span>
      </span> -->
      <span class="device-dropdown-trigger-text overflow-hidden text-nowrap">
        <span *ngIf="selectedDevice.username != null" class="text-truncate">{{selectedDevice.username}}</span>
        <span *ngIf="selectedDevice.username != null" class="flex-shrink-0">&nbsp;–&nbsp;</span>
        <span class="text-truncate">{{selectedDevice.device.name}}</span>
      </span>
      <!-- Alternative trigger truncation for narrow devices (otherwise we would only see ... everywhere) -->
      <span class="device-dropdown-trigger-text-narrow text-truncate">
        {{getSelectedItemText()}}
      </span>
    </div>
    <!-- Loading spinner -->
    <ng-template #dropdownLoading>
      <app-spinner class="device-dropdown-spinner"></app-spinner>
    </ng-template>
    <fa-icon [icon]="['fas', 'chevron-down']" class="arrow-icon"></fa-icon>
  </div>

  <!-- Dropdown content -->
  <div dropdown-content #itemContainer class="device-dropdown-content">
    <ng-container *ngFor="let items of dropdownItems">
      <!-- Device without users -->
      <app-dropdown-item *ngIf="items.length === 1 && items[0].username == null"
        class="option"
        [title]="items[0].device.name"
        [value]="items[0]"
      >
        <span *ngIf="items[0].device.name!='UNKNOWN'" class="label label-mobile">
          <fa-icon [icon]="['fas', 'mobile-alt']"></fa-icon>
        </span>

        <span *ngIf="items[0].device.name=='UNKNOWN'" class="label label-warning">
        <fa-icon [icon]="['fas', 'exclamation-triangle']" style="color:white"></fa-icon>
        </span>

        <span class="name-container">{{items[0].device.name}}</span>
      </app-dropdown-item>

      <!-- Use itemgroup if we have a device with users which means, the users instead of the device must be selected -->
      <app-dropdown-itemgroup *ngIf="items.length >= 1 && items[0].username != null" class="option-group">
        <app-dropdown-itemgroup-label [title]="items[0].device.name" class="option-group-label">
          <span class="label label-desktop">
            <fa-icon [icon]="['fas', 'desktop']"></fa-icon>
          </span>
          <span class="name-container">
            {{items[0].device.name}}
          </span>
          <span>
            <div class="user-count-box">
              {{items.length}} {{'HEADER.DEVICE_DROPDOWN_USERS' | translate}}
            </div>
          </span>
        </app-dropdown-itemgroup-label>
        <app-dropdown-item *ngFor="let item of items"
          class="option"
          [title]="item.username"
          [value]="item"
        >
          <span class="label label-user">
            <fa-icon [icon]="['fas', 'user']"></fa-icon>
          </span>
          <span class="name-container">
            {{item.username}}
          </span>
        </app-dropdown-item>
      </app-dropdown-itemgroup>
    </ng-container>
  </div>
</app-responsive-dropdown-scaffold>
